// Google reCAPTCHA disclaimer no longer required per Google policy change (April 2026)
const RecaptchaDisclaimer = ({ addClasses }) => {
    return null
    /*
    return (
        <p className={`text-light ${addClasses ? addClasses : 'text-xs'}`}>
            This site is protected by reCAPTCHA and the Google{' '}
            <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-primary transition-colors"
                aria-label="Privacy Policy (opens in new tab)"
            >
                Privacy Policy
            </a>{' '}
            and{' '}
            <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-primary transition-colors"
                aria-label="Terms of Service (opens in new tab)"
            >
                Terms of Service
            </a>{' '}
            apply.
        </p>
    )
    */
}

export default RecaptchaDisclaimer
